import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function formatDate(timestamp: number): string {
    return new Date(timestamp).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })
}

export function formatDateTime(timestamp: number): string {
    return new Date(timestamp).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    })
}

export function formatRelativeTime(timestamp: number): string {
    const now = Date.now()
    const diff = now - timestamp

    const seconds = Math.floor(diff / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (days > 7) {
        return formatDate(timestamp)
    } else if (days > 0) {
        return `${days}d ago`
    } else if (hours > 0) {
        return `${hours}h ago`
    } else if (minutes > 0) {
        return `${minutes}m ago`
    } else {
        return 'Just now'
    }
}

export function getInitials(name: string): string {
    return name
        .split(' ')
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 2)
}

export function truncate(str: string, length: number): string {
    if (str.length <= length) return str
    return str.slice(0, length) + '...'
}

export function getProjectStatusColor(status: string): string {
    const colors: Record<string, string> = {
        development: 'bg-blue-500',
        'pre-production': 'bg-purple-500',
        production: 'bg-green-500',
        post: 'bg-orange-500',
        delivered: 'bg-gray-500',
    }
    return colors[status] || 'bg-gray-500'
}

export function getProjectStatusLabel(status: string): string {
    const labels: Record<string, string> = {
        development: 'Development',
        'pre-production': 'Pre-Production',
        production: 'Production',
        post: 'Post-Production',
        delivered: 'Delivered',
    }
    return labels[status] || status
}
